<template>
	<vx-card :title="$t('CompanyForm.AdminResource')" no-shadow card-border>
		<p>{{ $t("CompanyModule.AdminResourceDescription") }}</p>

		<div class="vx-row">
			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					:label="$t('Username')"
					v-model="resource.username"
					v-validate="'required|alpha_num'"
					name="username"
				/>
				<span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first("username") }}</span>
			</div>

			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					:label="$t('Name')"
					v-model="resource.name"
					v-validate="'required|alpha_spaces'"
					name="name"
				/>
				<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
			</div>

			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					:label="$t('Lastname')"
					v-model="resource.lastname"
					v-validate="'required|alpha_spaces'"
					name="lastname"
				/>
				<span class="text-danger text-sm" v-show="errors.has('lastname')">{{ errors.first("lastname") }}</span>
			</div>
		</div>

		<div class="vx-row">
			<div id="div-email-content" :class="'vs-con-loading__container'" class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					:label="$t('Email')"
					v-model="resource.email"
					type="email"
					v-validate="'validatorEmail'"
					name="email"
				/>
				<span class="text-danger text-sm" v-show="!validatorErrors.email && !showEmailMessageOk">{{
					emailMessage
				}}</span>
				<span class="text-success text-sm" v-show="emailMessageRes === 'Ok' && showEmailMessageOk">{{
					this.$t("CompanyForm.ValidEmail")
				}}</span>
				<span class="text-danger text-sm" v-show="emailMessageRes === 'Existe' && showEmailMessageOk">{{
					this.$t("CompanyForm.EmailAlreadyExist")
				}}</span>
			</div>

			<div class="vx-col md:w-1/3 w-full">
				<vs-input
					class="w-full mt-4"
					:label="$t('Identification')"
					v-model="resource.identification"
					v-validate="'required'"
					name="identification"
				/>
				<span class="text-danger text-sm" v-show="errors.has('identification')">{{
					errors.first("identification")
				}}</span>
			</div>

			<div class="vx-col md:w-1/3 w-full"></div>
		</div>
	</vx-card>
</template>

<script>
import {Validator} from "vee-validate";
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	props: {
		dataEmail: {
			type: Function,
		},
	},
	data() {
		return {
			resource: {
				additional_info: {},
				email: "",
				identification: "",
				lastname: "",
				name: "",
				role_id: 1,
				typology_id: 0,
				username: "",
			},
			validatorErrors: {
				email: true,
			},
			emailMessage: this.$t("Login.ValidMessages.Email"),
			emailMessageRes: "",
			showEmailMessageOk: false,
			exist: false,
			activeAlert: true,
		};
	},
	methods: {
		getDataFormResource() {
			this.$emit("getFormDataResourceEmit", this.resource);
		},
		validatorEmail(value) {
			const regex =
				/^([a-z0-9-+*=&'/?^_}{~|`]+)(\.?[a-z0-9-+*=&'/?^_}{~|`]+)*@[a-z0-9]+((-|\.)[a-z0-9]+)*(\.[a-z]{1,20})$/;
			const regexTested = regex.test(value);
			this.validatorErrors.email = regexTested;
			if (regexTested) {
				this.validateExistEmail();
			}
			this.emailMessage = this.$t("Login.ValidMessages.Email");
			this.showEmailMessageOk = false;
			return regexTested;
		},
		validateExistEmail() {
			this.openLoadingInEmail();
			this.$store
				.dispatch("moduleResource/validateExistEmail", this.resource.email)
				.then((res) => {
					if (res.data) {
						this.emailMessageRes = "Existe";
						this.exist = true;
					} else {
						this.emailMessageRes = "Ok";
						this.exist = false;
					}
					this.showEmailMessageOk = true;
					this.closeLoadingInEmail();
					this.dataEmail(res.data);
				})
				.catch((err) => {
					this.closeLoadingInEmail();
					console.error(err);
				});
		},
		openLoadingInEmail() {
			this.$vs.loading({
				container: "#div-email-content",
				scale: 0.6,
			});
		},
		closeLoadingInEmail() {
			this.$vs.loading.close("#div-email-content > .con-vs-loading");
		},
	},
	created() {
		// Register Module Resource Module
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		// Create Custom Validators
		Validator.extend("validatorEmail", this.validatorEmail);
		new Validator({trueField: "validatorEmail"});
	},
};
</script>
